import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import CheckIcon from '@mui/icons-material/Check'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import useWindowDimensions from '../../_common/WindowDimesnions'
import CustomCheckboxField from '../../_common/_form_fields/CustomCheckboxField'
import SubscriptionServiceItem from './SubscriptionServiceItem'
import CustomCard from '../../_common/CustomCard'

const SubscriptionItem = (props) => {
  const {
    id,
    checked,
    renewable,
    title,
    base_price,
    currency,
    duration,
    services,
    setSubscriptionPackages,
  } = props
  const theme = useTheme()
  const { width } = useWindowDimensions()
  
  const [servicesData, setServicesData] = useState([])
  const [totalPrice, setTotalPrice] = useState(base_price)

  const wrapperStyle = {
    minHeight: '600px',
    margin: '0px 20px 10px 20px',
    background: theme.palette.oxfordBlue,
    borderRadius: '10px',
    boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.25)',
    padding: width >= constants.mdBreakpoint ? '20px' : '10px',
    color: 'white',
  }

  const titleStyle = {
    minHeight: '50px',
    fontSize: width >= constants.xlBreakpoint ? '20px' : '18px',
    textAlign: 'center',
    paddingLeft: '10px',
  }

  const priceStyle = {
    fontSize: width >= constants.xlBreakpoint ? '28px' : '24px',
    textAlign: 'center',
    color: theme.palette.violetsAreBlue,
  }

  const renewableStyle = {
    height: '50px',
    textAlign: 'center',
  }

  const servicesLabelStyle = {
    fontSize: width >= constants.xlBreakpoint ? '18px' : '16px',
    textAlign: 'center',
    color: theme.palette.greenSheen,
    paddingBottom: '20px',
  }

  const checkboxStyle = {
    width: '24px',
    height: '24px',
    borderRadius: '8px',
    background: 'white',
    color: theme.palette.oxfordBlue,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }

  const renewableCheckboxStyle = {
    color: 'white',

    '&.Mui-checked': {
      color: 'white',
    },

    '& .MuiSvgIcon-root': {
      fontSize: width >= constants.xlBreakpoint ? 32 : 28,
    },
  }

  const renewableCheckboxLabelStyle = {
    color: 'white',
    fontSize: width >= constants.xlBreakpoint ? '20px' : '17px',
  }

  const handleSelectSubscription = () => {
    setSubscriptionPackages(prev => {
      let result = []

      prev.forEach(p => {
        if (p.id === id) {
          result.push({ ...p, checked: !p.checked })
        } else {
          result.push({ ...p, checked: false })
        }
      })

      return result
    })
  }

  const handleClickRenewable = (event) => {
    event.stopPropagation()
  }

  const handleChangeRenewable = (value) => {
    setSubscriptionPackages(prev => {
      let result = []

      prev.forEach(p => {
        if (p.id === id) {
          result.push({ ...p, renewable: value })
        } else {
          result.push(p)
        }
      })

      return result
    })
  }

  useEffect(() => {
    const sortByPriority = (list) => {
      return [...list].sort((a, b) => a.priority - b.priority)
    }

    if (services && services.length > 0) {
      const services_data = sortByPriority(services)
      setServicesData(services_data)
    } else {
      setServicesData([])
    }
  }, [services])

  useEffect(() => {
    let total_price = parseFloat(base_price)

    services.forEach(s => {
      if (!s.is_mandatory && s.checked && s.price) {
        total_price = total_price + parseFloat(s.price)
      }
    })

    setTotalPrice(total_price)
  }, [services, base_price])
  
  return (
    <Box sx={wrapperStyle} onClick={() => handleSelectSubscription(id)}>
      <Stack
        direction='row'
        alignItems='flex-start'
        justifyContent='space-between'
      >
        <Box sx={checkboxStyle}>
          { checked && <CheckIcon /> }
        </Box>
        <Box sx={titleStyle}>{title.value}</Box>
        <Box></Box>
      </Stack>      
      <Box sx={priceStyle}>
        <Box component='span'>{totalPrice} </Box>
        <Box component='span' sx={{ textTransform: 'uppercase' }}>{currency} </Box>
        <Box component='span'>/ </Box>
        <Box component='span' sx={{ textTransform: 'capitalize' }}>{duration}</Box>
      </Box>
      <Box sx={renewableStyle} onClick={handleClickRenewable}>
        {
          checked &&
          <CustomCheckboxField
            label={defaultTexts.renewable}
            checked={renewable}
            handleChange={handleChangeRenewable}
            sx={renewableCheckboxStyle}
            sxLabel={renewableCheckboxLabelStyle}
          />
        }        
      </Box>
      <Box sx={servicesLabelStyle}>{defaultTexts.services}</Box>
      <CustomCard sx={{ height: '320px' }} marginRight={-18}>
        {
          servicesData.map((item, index) => (
            <SubscriptionServiceItem
              key={index}
              {...item}
              subscription_id={id}
              setSubscriptionPackages={setSubscriptionPackages}
              currency={currency}
            />
          ))
        }
      </CustomCard>
    </Box>
  )
}

export default SubscriptionItem